import axios from 'axios';
import store from '@/store/store';
import { NotificationHelper } from '@/utils/events';
import { ExtendedAxiosRequestConfig } from '@/connectors/axios-request-config.model';
import { RequestErrorHandler } from '@/connectors/request-error-handler.model';
import { ApplicationLayout } from '@/store/modules/application';
import { LocalStorageHelper } from '@/utils/local-storage.helper';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common.IndustryPortalClientId = LocalStorageHelper.getClientId();

const identity = LocalStorageHelper.getIdentity();

if (identity) {
  store.commit('user/login', identity);
  store.commit('application/changeLayout', ApplicationLayout.default);
  axios.defaults.headers.common.Authorization = 'Bearer ' + identity.accessToken;
}

let isRefreshing = false;
let subscribers: any[] = [];

function onRefreshed() {
  subscribers.map(cb => cb());
}

function subscribeTokenRefresh(cb: any) {
  subscribers.push(cb);
}

axios.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (error.config && error.response && error.response.status === 401) {
      const isLoggedIn = store.state.user.isLoggedIn;
      const refreshToken = store.state.user.refreshToken;

      if (isLoggedIn && refreshToken) {
        if (!isRefreshing) {
          isRefreshing = true;
          const success = await store.dispatch('user/login', refreshToken);
          isRefreshing = false;
          onRefreshed();
          subscribers = [];

          if (success) {
            error.config.headers.Authorization = axios.defaults.headers.common.Authorization;

            return axios.request(error.config);
          } else {
            await store.dispatch('user/logout');
            return Promise.reject(error);
          }
        } else {
          return new Promise(resolve => {
            subscribeTokenRefresh(() => {
              error.config.headers.Authorization = axios.defaults.headers.common.Authorization;
              resolve(axios(error.config));
            });
          });
        }
      }
    } else {
      const config = error.config as ExtendedAxiosRequestConfig;

      if (!!config.defaultErrorHandling) {
        let message = 'Error while sending the request. Please try again later.';

        if (error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }

        switch (config.defaultErrorHandling) {
          case RequestErrorHandler.Snackbar:
            NotificationHelper.showSnackBar(message, 4000);
            break;
          case RequestErrorHandler.Dialog:
            NotificationHelper.showAlertDialog('Alert', message);
            break;
        }
      }
    }
    return Promise.reject(error);
  }
);
